export default "__VITE_ASSET__Ce2xeECs__"